<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('media.create')
  }),
  computed: {
    ...mapState('newsMedia', ['routeKey', 'routes', 'form', 'item']),
    crumbs: (vm) => [
      { text: vm.$t('news.title'), to: { name: 'news.index' } },
      { text: vm.$t('news.edit', { id: vm.$route.params.newsId }), to: { name: 'news.edit' } },
      { text: vm.$t('media.title'), to: { name: 'news.media.index' } },
      { text: vm.$t('media.create') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('newsMedia/clearItem')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('newsMedia', ['createItem', 'updateItem'])
  }
}
</script>
